import { Amplify } from 'aws-amplify';

const outputs = {
    Auth: {
        Cognito: {
            userPoolId: process.env.NEXT_PUBLIC_COGNITO_USERPOOLID,
            userPoolClientId: process.env.NEXT_PUBLIC_COGNITO_CLIENTID
        },
    },
    API: {
        GraphQL: {
            endpoint: process.env.NEXT_PUBLIC_GQL_WEB_COSTUMER_URL,
            region: process.env.NEXT_PUBLIC_GQL_REGION,
            defaultAuthMode: process.env.NEXT_PUBLIC_GQL_DEFAULT_AUTH_MODE
        },
    },
}

Amplify.configure(outputs, { ssr: true });

export default outputs